import React from 'react';
import PropTypes from 'prop-types';
import { MapPin } from 'lucide-react';

function StartupRowCountry({
  country, city, literalsOnBoarding,
}) {
  return (
    <div className='company_country'>
      {(country || city) && (
        <>
          <MapPin size={16} />
          {[city, literalsOnBoarding.countries[country]].filter(Boolean).join(', ')}
        </>
      )}
    </div>
  );
}

StartupRowCountry.propTypes = {
  country: PropTypes.string,
  city: PropTypes.string,
  literalsOnBoarding: PropTypes.object.isRequired,
};

export default StartupRowCountry;
